import React, { SyntheticEvent } from 'react';

type CustomButtonType = 'default'|'cancel'|'default-split'|'cancel-split'|'add'|'secondary-modal'|'secondary-default'|'secondary-cancel';

export default function CustomButton({
  type = 'default',
  disabled = false,
  children = '',
  onClick,
}: {
  type?: CustomButtonType,
  disabled?: boolean,
  children?: React.ReactNode,
  onClick: () => void,
}) {
  const cancelEvent = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };
  switch (type) {
    case 'default':
    default:
      return (
        <button
          className={`submit_bt${disabled ? ' disable_bt' : ''}`}
          type="button"
          disabled={disabled}
          onClick={() => onClick()}
        >
          {children}
        </button>
      );
    case 'cancel':
      return (
        <button
          className={`submit_bt_3${disabled ? ' disable_bt' : ''}`}
          type="button"
          disabled={disabled}
          onClick={() => onClick()}
        >
          {children}
        </button>
      );
    case 'default-split':
      return (
        <button
          className={`submit_bt_2${disabled ? ' disable_bt' : ''}`}
          type="button"
          disabled={disabled}
          onClick={() => onClick()}
        >
          {children}
        </button>
      );
    case 'cancel-split':
      return (
        <button
          className={`submit_bt_1${disabled ? ' disable_bt' : ''}`}
          type="button"
          disabled={disabled}
          onClick={() => onClick()}
        >
          {children}
        </button>
      );
    case 'add':
      return (
        <>
          { /* eslint-disable-next-line max-len */}
          { /* eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */ }
          <a
            className={`ps_add_bt_100${disabled ? ' disable_bt' : ''}`}
            onClick={(e) => { cancelEvent(e); onClick(); }}
          >
            <img src="/img/common/add_bt.svg" alt="" />
            <span>{children}</span>
          </a>
        </>
      );
    case 'secondary-modal':
      return (
        <>
          { /* eslint-disable-next-line jsx-a11y/anchor-is-valid */ }
          <a
            href="#"
            className={`modal_pop${disabled ? ' disable_bt' : ''}`}
            onClick={(e) => { cancelEvent(e); onClick(); }}
          >
            {children}
          </a>
        </>
      );
    case 'secondary-default':
      return (
        <button
          type="button"
          className={`bt_text_link color_orange${disabled ? ' disable_bt' : ''}`}
          disabled={disabled}
          onClick={() => onClick()}
        >
          {children}
        </button>
      );
    case 'secondary-cancel':
      return (
        <button
          type="button"
          className={`bt_text_link color_gray${disabled ? ' disable_bt' : ''}`}
          disabled={disabled}
          onClick={() => onClick()}
        >
          {children}
        </button>
      );
  }
}
